export const resources = {
  DetectedObjectsComponentPictureLabel: ''
};
